export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 p-8 md:p-14">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-background-50"></div>
            <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-background-50"></div>
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/25 text-background-50 text-sm font-medium mb-4 whitespace-nowrap">
                随时随地 · 畅享阅读
              </span>
              <h2 className="text-3xl md:text-4xl font-heading text-background-50 mb-4">羞羞漫画 APP</h2>
              <p className="text-background-50/90 text-base md:text-lg leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                下载羞羞漫画 APP，享受更流畅的下拉式阅读体验。离线缓存、夜间模式、智能追更提醒，随时随地免费看韩漫日漫国漫大全集。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a href="#contact" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-500 font-semibold text-base hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
                <a href="#contact" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-base hover:bg-background-50/15 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 w-[200px] sm:w-[240px] h-[400px] sm:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20reading%20app%20interface%20with%20colorful%20comic%20panels%2C%20warm%20coral%20accent%20UI%20design%2C%20modern%20flat%20illustration%20style%2C%20floating%20phone%20on%20transparent%20background%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=240&height=480&seq=app-phone-mockup-01&orientation=portrait"
                alt="羞羞漫画APP手机界面展示"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}